import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Loader } from '@googlemaps/js-api-loader';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { AllCommunityModule } from 'ag-grid-community';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-084357}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{RGS_Plus}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{RGS_Plus}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{RGS_Plus}_need_to_be_licensed___{RGS_Plus}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{30_January_2027}____[v3]_[01]_MTgwMTI2NzIwMDAwMA==3f0a9e28432fcf7e1b447b2b725807e7',
);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

const googleMapsLoader = new Loader({
  apiKey: environment.googleMapsApiKey,
  version: 'weekly',
  language: 'nl',
  region: 'NL',
});

googleMapsLoader.importLibrary('maps');
googleMapsLoader.importLibrary('places');
googleMapsLoader.importLibrary('marker');
